export const HAS_REGULATION = 'JA';
export const REGULATION_ACRU = 'ACRU';
export const REGULATION_RCEV = 'RCEV';
export const REGULATION_VUBZK = 'VUBZK';
export const REGULATION_VBRA = 'VBRA';
export const REGULATION_KU = 'KU';
export const REGULATION_UVCN = 'UVCN';
